export default "__VITE_ASSET__CSASIVLC__"